import { of as observableOf, Subscription } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { Group } from '../shared';
import { AppStore } from '../store';

@Component({
  selector: 'auth-page',
  templateUrl: './auth-page.component.html',
})
export class AuthPageComponent implements OnInit, OnDestroy {
  showKawaaPrivacy: boolean = true; // Used to show or not all the blabla around RGPD
  isGroup: boolean = false; // Used to show the left content of auth-box

  subscription: Subscription;

  constructor(
    private _appStore: AppStore,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);

    const masterGroupId: string = this._route.snapshot.params['id'] || this._route.parent.snapshot.params['id'];

    if (masterGroupId) {
      this.subscription = this._appStore
        .load('Group', masterGroupId)
        .entity.pipe(catchError(() => observableOf(null)))
        .subscribe((group: Group | null) => {
          if (!group) return;
          this.isGroup = true;

          if (group.options && group.options.cgu_link) {
            this.showKawaaPrivacy = false;
          }
        });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
